module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter_title"
  }, [_c('a', {
    attrs: {
      "id": "page_264"
    }
  }), _c('a', {
    attrs: {
      "id": "ded"
    }
  }), _vm._v("DEDICATION")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("I wrote this book in honor of the family I grew up with—my great-grandparents, grandparents, uncles, aunts, mom, dad, and brother. And especially in memory of Octavio Rodriguez, Uncle Andy, and Aunt JoAnn.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("— JOSEF CENTENO")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0264-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23768659","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03dedication.vue
// module id = 66
// module chunks = 0